export const BIDDING_INFO_DEFAULT_SOLR_PARAMS = {
  T: "",
  beginAmount: "",
  beginTime: "",
  biddingType: "",
  endAmount: "",
  endTime: "",
  excludeWord: "",
  filterMode: "2,1",
  fundsSourceList: "",
  hasAgent: "",
  hasLinkName: "",
  hasPhone: "",
  keyword: "",
  keywordsAndOr: "|", // 且或关系、& = 且 、 | = 或
  newAreas: "",
  progIdAndNoticeSegmentTypeMaps: "{}",
  purchasingUnitIdList: "",
  registrationStatus: "",
  searchMode: "",
  sortType: "2",
  summaryType: "0",
  threeClassifyTagStr: "",
  timeType: "8",
};

export const BIDDING_INFO_TIME_LIST = [
  {
    id: 7,
    text: "当日",
  },
  {
    id: 2,
    text: "近7天",
  },
  {
    id: 3,
    text: "近30天",
  },
  {
    id: 8,
    text: "近90天",
  },
  {
    id: 9,
    text: "近半年",
  },
  {
    id: 1,
    text: "近一年",
  },
  {
    id: 40,
    text: "往年",
  },
  {
    id: 4,
    text: "自定义",
  },
];
export const BIDDING_INFO_AMOUNT = [
  {
    id: -1,
    beginAmount: "",
    endAmount: "",
    text: "不限",
  },
  {
    id: 2,
    beginAmount: "",
    endAmount: "100000",
    text: "10万以下",
  },
  {
    id: 3,
    beginAmount: "100000",
    endAmount: "500000",
    text: "10万-50万",
  },
  {
    id: 4,
    beginAmount: "500000",
    endAmount: "1000000",
    text: "50万-100万",
  },
  {
    id: 5,
    beginAmount: "1000000",
    endAmount: "2000000",
    text: "100万-200万",
  },
  {
    id: 6,
    beginAmount: "2000000",
    endAmount: "",
    text: "200万以上",
  },
  {
    id: 99,
    beginAmount: "",
    endAmount: "",
    text: "",
    hide: true,
  },
];
export const BIDDING_INFO_SEARCH_SCOPE = [
  {
    text: "标题",
    id: 2,
  },
  {
    text: "正文",
    id: 1,
    tip: "公告正文内容，不包含标题和附件",
  },
  {
    text: "附件",
    id: 10,
    tip: "公告中的附件文件，非文本类附件可能识别不完整",
  },

  {
    text: "产品/标的",
    id: 9,
    tip: "指招标采购的具体货物、工程或服务对象，标的内容为千里马智能提取，可能存在遗漏",
  },
  {
    text: "招标单位",
    id: 4,
  },
  {
    text: "中标单位",
    id: 5,
  },
  {
    text: "代理单位",
    id: 6,
  },
];
export const BIDDING_INFO_BIDDING_TYPE = [
  {
    id: -1,
    text: "全部",
  },
  {
    id: 0,
    text: "公开招标",
    tip: "政府采购的主要采购方式，根据招标投标法进行招标并公示",
  },
  {
    id: 1,
    text: "邀请招标",
    tip: "指采购人以投标邀请书的方式邀请特定的法人或者其他组织投标",
  },
  {
    id: 2,
    text: "竞争性谈判/磋商",
    tip: "采购人或代理机构通过与多家供应商(不少3 家) 进行谈判，最后从中确定中标供应商的一种采购方式",
  },
  {
    id: 3,
    text: "单一来源",
    tip: "采购人向唯一供应商进行采购的方式",
  },
  {
    id: 6,
    text: "电子卖场",
    tip: "通过政府采购中心建立的电子买卖交易平台进行采购的采购方式，电子卖场的供应商入围方式采用资格入围法",
  },
];
export const BIDDING_INFO_REGISTRATION = [
  {
    id: -1,
    text: "不限",
  },
  {
    id: 0,
    text: "报名或投标未截止",
  },
  {
    id: 1,
    text: "报名未截止",
  },
  {
    id: 2,
    text: "投标未截止",
  },
  {
    id: -2,
    text: "无报名和投标时间",
  },
];
export const BIDDING_INFO_FUND_SOURCE = [
  {
    id: -1,
    text: "全部",
  },
  {
    id: 1,
    text: "财政资金",
  },
  {
    id: 2,
    text: "专项资金及债券",
  },
  {
    id: 3,
    text: "银行贷款",
  },
  {
    id: 4,
    text: "投资/融资",
  },
  {
    id: 5,
    text: "单位自筹",
  },
];
export const BIDDING_INFO_HAS_AGENT = [
  {
    id: -1,
    text: "全部",
  },
  {
    id: 1,
    text: "有代理机构",
  },
  {
    id: 0,
    text: "无代理机构",
  },
];
export const BIDDING_INFO_HAS_PHONE = [
  {
    id: -1,
    text: "全部",
  },
  {
    id: 3,
    text: "有招标联系电话",
  },
  {
    id: 4,
    text: "有中标联系电话",
  },
];
export const BIDDING_INFO_HAS_LINK_NAME = [
  {
    id: -1,
    text: "全部",
  },
  {
    id: 1,
    text: "有招标联系人",
  },
  {
    id: 2,
    text: "有中标联系人",
  },
];
export const BIDDING_INFO_MODE_LIST = [
  {
    id: 1,
    text: "精准",
    tip: "关键词完整出现在目标搜索范围中",
  },
  {
    id: 0,
    text: "模糊",
    tip: "关键词根据语义自动拆分，出现在目标搜索范围的不同位置",
  },
];
